// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from './store'
import Vuetify from 'vuetify'
import VueHeadful from 'vue-headful'
import VueCookies from 'vue-cookies'
import 'vuetify/dist/vuetify.min.css'
import Vuelidate from 'vuelidate'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import VueScrollTo from 'vue-scrollto'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import '@fortawesome/fontawesome-free/css/all.css'
// import '@mdi/font/css/materialdesignicons.css'
Vue.component('vue-headful', VueHeadful)
Vue.use(Vuelidate)
Vue.use(VueCookies)
Vue.use(wysiwyg, {})
Vue.use(VueScrollTo)

let themes = [
  {
    primary: '#283593',
    secondary: '#1A237E',
    accent: '#D50000',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
]

Vue.use(Vuetify, {
  theme: themes[0]
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js